<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getLeases"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:headings>
        <div class="col-md-2">From</div>
        <div class="col-md-2">To</div>
        <div class="col-md-2">Inv Frequency</div>
  <div class="col-md-1">Amount</div>
        <div class="col-md-2">Tenant</div>
        <div class="col-md-2">Status</div>
        <div class="col-md-1 text-left text-md-right">Action</div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-md-2 my-auto">
          {{
            moment(new Date(slotProps.item.from)).format(
              "DD MMM YY, HH:mm"
            )
          }}
        </div>

          <div class="col-md-2 my-auto">
          {{
            moment(new Date(slotProps.item.to)).format(
              "DD MMM YY, HH:mm"
            )
          }}
        </div>

        <div class="col-md-2 my-auto">
           <p class="m-0">{{ slotProps.item.invoice_frequency }}</p>
        </div>

          <div class="col-md-1 my-auto">
           <p class="m-0">{{ slotProps.item.invoice_amount  | currency}}</p>
        </div>

        <div class="col-md-2 my-auto">
         <router-link :to="{name:'tenants-show',params:{id:slotProps.item.tenant.id}}" class="m-0" v-if="slotProps.item.tenant">{{ slotProps.item.tenant.name }}</router-link>
        </div>

        <div class="col-md-2 my-auto">
          <p class="m-0 text-body">{{ slotProps.item.status}}

            <span v-if="slotProps.item.is_terminated" class="text-danger">Terminated</span>
          </p>
        </div>

        

        <div class="col-md-1 my-auto text-left text-md-right pt-3 pt-md-0">
          <router-link
            v-b-tooltip.hover
            title="view"
            :to="{
              name: 'leases-show',
              params: { id: slotProps.item.id },
            }"
            class="text-info table-action-icon  table-action-icon"
          >
            <i class="lni lni-search-alt"></i>
          </router-link>

          

        </div>
      </template>
    </data-table>


    <b-modal
      :hide-footer="true"
      title="Lease Details"
      size="xl"
      v-model="leaseShow"
      :no-close-on-route-change="true"
      :lazy="true"
    >
      <table class="table table-sm border" v-if="selectedLease">
        <tr>
          <td width="20%" class="bg-primary text-white">CODE</td>
          <td width="36%" class="bg-primary text-white">DESCRIPTION</td>
          <td width="8%" class="bg-primary text-white">QUANITY</td>
          <td width="18%" class="bg-primary text-white text-right">AMOUNT</td>
          <td width="18%" class="bg-primary text-white text-right">TOTAL</td>
        </tr>

        <tr v-for="line in selectedLease.lease_items" :key="line.id">
          <td>
            {{ line.code }}
          </td>
          <td>
            {{ line.description }}
          </td>
          <td>
            {{ line.quantity }}
          </td>
          <td class="text-right">
            <strong> {{ line.line_amount }}</strong>
          </td>
          <td class="text-right">
            <strong> {{ line.line_total_amount }}</strong>
          </td>
        </tr>

        <tr>
          <td class="border-0"></td>
          <td class="border-0"></td>
          <td class="border-0"></td>
          <td class="border-0"></td>
          <td class="border-0"></td>
        </tr>

        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td class="text-right">SUB TOTAL</td>
          <td class="text-right">
            <strong> {{ selectedLease.sub_total_amount }}</strong>
          </td>
        </tr>

        <tr>
          <td></td>
          <td></td>
            <td></td>
          <td class="text-right">DISCOUNT</td>
          <td class="text-right">
            <strong> {{ selectedLease.discount_amount }}</strong>
          </td>
        </tr>

        <tr v-if="selectedLease.vat_amount">
          <td></td>
          <td></td>
            <td></td>
          <td class="text-right">VAT</td>
          <td class="text-right">
            <strong>{{ selectedLease.vat_amount }} </strong>
          </td>
        </tr>

        <tr>
          <td colspan="3" class="bg-light"></td>
          <td class="text-right bg-light lead">
            <strong>TOTAL DUE</strong>
          </td>
          <td class="text-right bg-light lead">
            <strong>{{ selectedLease.total_amount }}</strong>
          </td>
        </tr>
      </table>
    </b-modal>
  </div>
</template>

<script>
import propertyRepo from "@/api/repos/propertyRepo";
import dataTable from "@/components/common/DataTable";


export default {
  props: ["propertyId"],

  components: {
    dataTable,
  },

  data() {
    return {
      leaseShow: false,
      selectedLease: null,
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "created_at", label: "Latest", order: "desc" },
      sortOptions: [
        { column: "created_at", label: "Oldest", order: "asc" },
        { column: "created_at", label: "Latest", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getLeases({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      search: "",
    });
  },
  methods: {
    async getLeases(e) {
      this.isLoad = true;
      try {
        let { data } = await propertyRepo.propertyLeases(
          this.propertyId,
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.leases.data;
        this.totalRows = data.leases.total;
        this.page = data.leases.current_page;
        this.fromRow = data.leases.from;
        this.toRow = data.leases.to;
        this.lastPage = data.leases.last_page;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },
    async markPaid(id) {
      this.items.forEach((i) => {
        if (i.id == id) {
          i.is_paid = 1;
        }
      });
      try {
        await propertyRepo.leasePaid(id);
      } catch (error) {
        console.log(error);
        this.$root.$bvToast.toast("Something went wrong", {
          title: "Whoops",
          autoHideDelay: 3000,
          variant: "danger",
        });
        this.items.forEach((i) => {
          if (i.id == id) {
            i.is_paid = 0;
          }
        });
      }
    },
    async markUnpaid(id) {
      this.items.forEach((i) => {
        if (i.id == id) {
          i.is_paid = 0;
        }
      });
      try {
        await propertyRepo.leaseUnpaid(id);
      } catch (error) {
        console.log(error);
        this.$root.$bvToast.toast("Something went wrong", {
          title: "Whoops",
          autoHideDelay: 3000,
          variant: "danger",
        });
        this.items.forEach((i) => {
          if (i.id == id) {
            i.is_paid = 1;
          }
        });
      }
    },
     printLease(job,uid){
     window.open(`/pdf/reports/job/${job.uid}/lease/${uid}?cid=${job.company_id}`)
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
